import { useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import { AirplaneTilt, MapPin, BookOpenText } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Trips() {
  const [trips, setTrips] = useState(null);
  const [gen, setGen] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/trips").then((r) => setTrips(r.data)).catch(() => setTrips([])); }, []);

  const makeStory = async (t) => {
    setGen(t.id);
    try {
      const { data } = await api.post("/stories/generate", { city: t.city, country: t.country });
      toast.success("Story drafted");
      nav(`/stories/${data.id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not generate story");
    }
    setGen(null);
  };

  return (
    <div className="mx-auto max-w-[1400px]">
      <p className="overline text-[#F27A54]">Auto-detected</p>
      <h1 className="mt-1 font-display text-3xl font-black tracking-tight">Trips & Location Clusters</h1>
      <p className="mt-1 text-sm text-muted-foreground">Photos grouped by city and month — draft location stories ready for TravelerPulse.</p>

      {trips === null ? (
        <p className="mt-8 text-muted-foreground">Loading…</p>
      ) : trips.length === 0 ? (
        <div className="mt-16 grid place-items-center text-center">
          <AirplaneTilt size={44} weight="thin" className="text-zinc-300" />
          <p className="mt-3 font-display font-bold">No trips detected yet</p>
          <p className="text-sm text-muted-foreground">Upload geolocated photos to auto-cluster them into trips.</p>
        </div>
      ) : (
        <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {trips.map((t) => (
            <Card key={t.id} className="overflow-hidden rounded-md border border-border shadow-none transition-transform duration-200 hover:-translate-y-1 hover:shadow-sm">
              <div className="grid grid-cols-3 gap-0.5 bg-zinc-100">
                {t.photos.slice(0, 3).map((pid) => (
                  <img key={pid} src={imageUrl(pid)} alt="" className="aspect-square w-full object-cover" />
                ))}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-1.5 text-[#F27A54]"><MapPin size={15} weight="fill" /><h3 className="font-display font-bold">{t.city}</h3></div>
                <p className="text-xs text-muted-foreground">{t.country}</p>
                <div className="mt-2 flex items-center justify-between text-xs">
                  <span className="font-mono-p text-zinc-600">{t.start_date} → {t.end_date}</span>
                  <span className="rounded-sm bg-zinc-100 px-2 py-0.5 font-semibold">{t.count} photos</span>
                </div>
                <div className="mt-3 flex items-center gap-2">
                  <Button size="sm" onClick={() => makeStory(t)} disabled={gen === t.id}
                    data-testid={`trip-story-${t.id}`}
                    className="h-8 gap-1 rounded-md bg-[#F27A54] hover:bg-[#d9633f]">
                    <BookOpenText size={13} weight="bold" />{gen === t.id ? "Drafting…" : "Generate Story"}
                  </Button>
                  <Link to={`/library`} className="text-xs font-semibold text-[#F27A54] hover:underline">View photos →</Link>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
